<template>
    <div id="last_update_component">
        <span class="text">{{ 'last_update' | i18n }}</span>
        <span class="date">{{ date.date | showHour }}</span>
        <span class="user">{{ date.name }}</span>
    </div>
</template>

<script>

    export default {
        name: 'LastUpdate',
        props: { data: Object },
        data () {
            return {
            }
        },
        computed: {
            date(){
                if( typeof this.data !== 'undefined' ) {
                    return this.data;
                }
                else {
                    return {
                        last_update: '',
                        name: ''
                    }
                }
            }
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    #last_update_component {
        background: url(/img/clock.svg);
        background-size: 16px;
        background-repeat: no-repeat;
        background-position: left center;
        padding-left: 25px;
        margin-top: 20px;
        width: 100%;
        border-top: 1px solid #ccc;
        padding-top: 5px;

        span.text {
            font-size: 12px;
            font-family: Roboto-Light;
        }
        span.date {
            font-family: inherit;
            font-weight: bold;
            font-size: 12px;
            padding: 0 10px;
        }
        span.user {
            font-style: italic;
            font-size: 12px;
        }
    }

</style>
